/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CompleteInvoicePreview,
  CreateInvoice,
  CustomCreateInvoice,
  DocumentVersion,
  DocumentVersionList,
  Error,
  GetInvoiceByIdParams,
  GetInvoicesParams,
  GetShareableInvoiceHtmlParams,
  GetShareableInvoicePdfParams,
  Invoice,
  InvoiceList,
  PartialInvoicePreview,
  RenderDocumentHtmlParams,
  RenderDocumentPdfParams,
  RenderInvoicePreviewParams,
  UpdateInvoice,
  ValidationError,
  VoidInvoiceBody
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Retrieve invoice data using a shareable token. No authentication required. Returns full invoice data for rendering.
 * @summary View shareable invoice
 */
export type getShareableInvoiceResponse200 = {
  data: Invoice
  status: 200
}

export type getShareableInvoiceResponse404 = {
  data: void
  status: 404
}

export type getShareableInvoiceResponseSuccess = (getShareableInvoiceResponse200) & {
  headers: Headers;
};
export type getShareableInvoiceResponseError = (getShareableInvoiceResponse404) & {
  headers: Headers;
};

export type getShareableInvoiceResponse = (getShareableInvoiceResponseSuccess | getShareableInvoiceResponseError)

export const getGetShareableInvoiceUrl = (shareableId: string,) => {


  

  return `/invoices/shareable/${shareableId}`
}

export const getShareableInvoice = async (shareableId: string, options?: RequestInit): Promise<getShareableInvoiceResponse> => {
  
  return customFetch<getShareableInvoiceResponse>(getGetShareableInvoiceUrl(shareableId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Get invoice as HTML preview using a shareable token. No authentication required. Supports multiple languages via locale query parameter.
 * @summary Get shareable invoice as HTML
 */
export type getShareableInvoiceHtmlResponse200 = {
  data: string
  status: 200
}

export type getShareableInvoiceHtmlResponse404 = {
  data: void
  status: 404
}

export type getShareableInvoiceHtmlResponseSuccess = (getShareableInvoiceHtmlResponse200) & {
  headers: Headers;
};
export type getShareableInvoiceHtmlResponseError = (getShareableInvoiceHtmlResponse404) & {
  headers: Headers;
};

export type getShareableInvoiceHtmlResponse = (getShareableInvoiceHtmlResponseSuccess | getShareableInvoiceHtmlResponseError)

export const getGetShareableInvoiceHtmlUrl = (shareableId: string,
    params?: GetShareableInvoiceHtmlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/invoices/shareable/${shareableId}/html?${stringifiedParams}` : `/invoices/shareable/${shareableId}/html`
}

export const getShareableInvoiceHtml = async (shareableId: string,
    params?: GetShareableInvoiceHtmlParams, options?: RequestInit): Promise<getShareableInvoiceHtmlResponse> => {
  
  return customFetch<getShareableInvoiceHtmlResponse>(getGetShareableInvoiceHtmlUrl(shareableId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Download invoice as PDF using a shareable token. No authentication required. Supports multiple languages via locale query parameter.
 * @summary Download shareable invoice as PDF
 */
export type getShareableInvoicePdfResponse200 = {
  data: Blob
  status: 200
}

export type getShareableInvoicePdfResponse404 = {
  data: void
  status: 404
}

export type getShareableInvoicePdfResponseSuccess = (getShareableInvoicePdfResponse200) & {
  headers: Headers;
};
export type getShareableInvoicePdfResponseError = (getShareableInvoicePdfResponse404) & {
  headers: Headers;
};

export type getShareableInvoicePdfResponse = (getShareableInvoicePdfResponseSuccess | getShareableInvoicePdfResponseError)

export const getGetShareableInvoicePdfUrl = (shareableId: string,
    params?: GetShareableInvoicePdfParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/invoices/shareable/${shareableId}/pdf?${stringifiedParams}` : `/invoices/shareable/${shareableId}/pdf`
}

export const getShareableInvoicePdf = async (shareableId: string,
    params?: GetShareableInvoicePdfParams, options?: RequestInit): Promise<getShareableInvoicePdfResponse> => {
  
  return customFetch<getShareableInvoicePdfResponse>(getGetShareableInvoicePdfUrl(shareableId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Download invoice as e-SLOG 2.0 XML (Slovenian electronic invoice format) using a shareable token. No authentication required. Only available for Slovenian entities with valid e-SLOG validation.
 * @summary Download shareable invoice as e-SLOG XML
 */
export type getShareableInvoiceEslogResponse200 = {
  data: string
  status: 200
}

export type getShareableInvoiceEslogResponse404 = {
  data: void
  status: 404
}

export type getShareableInvoiceEslogResponseSuccess = (getShareableInvoiceEslogResponse200) & {
  headers: Headers;
};
export type getShareableInvoiceEslogResponseError = (getShareableInvoiceEslogResponse404) & {
  headers: Headers;
};

export type getShareableInvoiceEslogResponse = (getShareableInvoiceEslogResponseSuccess | getShareableInvoiceEslogResponseError)

export const getGetShareableInvoiceEslogUrl = (shareableId: string,) => {


  

  return `/invoices/shareable/${shareableId}/eslog`
}

export const getShareableInvoiceEslog = async (shareableId: string, options?: RequestInit): Promise<getShareableInvoiceEslogResponse> => {
  
  return customFetch<getShareableInvoiceEslogResponse>(getGetShareableInvoiceEslogUrl(shareableId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Create a new invoice with line items.
Customer is optional - can be omitted for retail/convenience store sales where customer information isn't needed, or added inline without referencing a customer_id.
The invoice number is auto-generated based on the entity's number format settings.
Taxes are calculated automatically based on the tax rates provided.
 * @summary Create a new invoice
 */
export type createInvoiceResponse201 = {
  data: Invoice
  status: 201
}

export type createInvoiceResponse400 = {
  data: Error
  status: 400
}

export type createInvoiceResponse401 = {
  data: Error
  status: 401
}

export type createInvoiceResponse403 = {
  data: Error
  status: 403
}

export type createInvoiceResponse404 = {
  data: Error
  status: 404
}

export type createInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type createInvoiceResponse500 = {
  data: Error
  status: 500
}

export type createInvoiceResponseSuccess = (createInvoiceResponse201) & {
  headers: Headers;
};
export type createInvoiceResponseError = (createInvoiceResponse400 | createInvoiceResponse401 | createInvoiceResponse403 | createInvoiceResponse404 | createInvoiceResponse422 | createInvoiceResponse500) & {
  headers: Headers;
};

export type createInvoiceResponse = (createInvoiceResponseSuccess | createInvoiceResponseError)

export const getCreateInvoiceUrl = () => {


  

  return `/invoices`
}

export const createInvoice = async (createInvoice: CreateInvoice, options?: RequestInit): Promise<createInvoiceResponse> => {
  
  return customFetch<createInvoiceResponse>(getCreateInvoiceUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createInvoice,)
  }
);}
  

/**
 * Retrieve a paginated list of invoices with optional filtering and sorting.
Supports cursor-based pagination, flexible JSON querying with MongoDB-style operators, full-text search, and sorting.
 * @summary List all invoices
 */
export type getInvoicesResponse200 = {
  data: InvoiceList
  status: 200
}

export type getInvoicesResponse400 = {
  data: Error
  status: 400
}

export type getInvoicesResponse401 = {
  data: Error
  status: 401
}

export type getInvoicesResponse403 = {
  data: Error
  status: 403
}

export type getInvoicesResponse404 = {
  data: Error
  status: 404
}

export type getInvoicesResponse500 = {
  data: Error
  status: 500
}

export type getInvoicesResponseSuccess = (getInvoicesResponse200) & {
  headers: Headers;
};
export type getInvoicesResponseError = (getInvoicesResponse400 | getInvoicesResponse401 | getInvoicesResponse403 | getInvoicesResponse404 | getInvoicesResponse500) & {
  headers: Headers;
};

export type getInvoicesResponse = (getInvoicesResponseSuccess | getInvoicesResponseError)

export const getGetInvoicesUrl = (params?: GetInvoicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/invoices?${stringifiedParams}` : `/invoices`
}

export const getInvoices = async (params?: GetInvoicesParams, options?: RequestInit): Promise<getInvoicesResponse> => {
  
  return customFetch<getInvoicesResponse>(getGetInvoicesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Create an invoice with pre-calculated totals from an external ERP or accounting system.
The caller provides `total`, `total_with_tax`, `total_discount`, and `taxes` at the document level, and `total`/`total_with_tax` on each line item.
When `calculation_mode` is omitted, Space Invoices preserves pass-through behavior and accepts the supplied totals as-is.
When `calculation_mode` is provided, Space Invoices validates the supplied totals against that calculation mode before creating the document.
All other logic (numbering, fiscalization, customer handling, payments, lifecycle hooks) is identical to the standard create endpoint.
 * @summary Create invoice with pre-calculated totals
 */
export type createCustomInvoiceResponse201 = {
  data: Invoice
  status: 201
}

export type createCustomInvoiceResponse400 = {
  data: Error
  status: 400
}

export type createCustomInvoiceResponse401 = {
  data: Error
  status: 401
}

export type createCustomInvoiceResponse403 = {
  data: Error
  status: 403
}

export type createCustomInvoiceResponse404 = {
  data: Error
  status: 404
}

export type createCustomInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type createCustomInvoiceResponse500 = {
  data: Error
  status: 500
}

export type createCustomInvoiceResponseSuccess = (createCustomInvoiceResponse201) & {
  headers: Headers;
};
export type createCustomInvoiceResponseError = (createCustomInvoiceResponse400 | createCustomInvoiceResponse401 | createCustomInvoiceResponse403 | createCustomInvoiceResponse404 | createCustomInvoiceResponse422 | createCustomInvoiceResponse500) & {
  headers: Headers;
};

export type createCustomInvoiceResponse = (createCustomInvoiceResponseSuccess | createCustomInvoiceResponseError)

export const getCreateCustomInvoiceUrl = () => {


  

  return `/invoices/custom`
}

export const createCustomInvoice = async (customCreateInvoice: CustomCreateInvoice, options?: RequestInit): Promise<createCustomInvoiceResponse> => {
  
  return customFetch<createCustomInvoiceResponse>(getCreateCustomInvoiceUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customCreateInvoice,)
  }
);}
  

/**
 * Retrieve a single invoice by its unique identifier. Returns the complete invoice details including all line items, customer information, and calculated totals.
 * @summary Get invoice by ID
 */
export type getInvoiceByIdResponse200 = {
  data: Invoice
  status: 200
}

export type getInvoiceByIdResponse401 = {
  data: Error
  status: 401
}

export type getInvoiceByIdResponse403 = {
  data: Error
  status: 403
}

export type getInvoiceByIdResponse404 = {
  data: Error
  status: 404
}

export type getInvoiceByIdResponse500 = {
  data: Error
  status: 500
}

export type getInvoiceByIdResponseSuccess = (getInvoiceByIdResponse200) & {
  headers: Headers;
};
export type getInvoiceByIdResponseError = (getInvoiceByIdResponse401 | getInvoiceByIdResponse403 | getInvoiceByIdResponse404 | getInvoiceByIdResponse500) & {
  headers: Headers;
};

export type getInvoiceByIdResponse = (getInvoiceByIdResponseSuccess | getInvoiceByIdResponseError)

export const getGetInvoiceByIdUrl = (id: string,
    params?: GetInvoiceByIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/invoices/${id}?${stringifiedParams}` : `/invoices/${id}`
}

export const getInvoiceById = async (id: string,
    params?: GetInvoiceByIdParams, options?: RequestInit): Promise<getInvoiceByIdResponse> => {
  
  return customFetch<getInvoiceByIdResponse>(getGetInvoiceByIdUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update an existing invoice.
Creates a version snapshot before applying changes.
Cannot update voided or FURS-fiscalized invoices.
If items are provided, they replace all existing items.
 * @summary Update an invoice
 */
export type updateInvoiceResponse200 = {
  data: Invoice
  status: 200
}

export type updateInvoiceResponse400 = {
  data: Error
  status: 400
}

export type updateInvoiceResponse401 = {
  data: Error
  status: 401
}

export type updateInvoiceResponse403 = {
  data: Error
  status: 403
}

export type updateInvoiceResponse404 = {
  data: Error
  status: 404
}

export type updateInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type updateInvoiceResponse500 = {
  data: Error
  status: 500
}

export type updateInvoiceResponseSuccess = (updateInvoiceResponse200) & {
  headers: Headers;
};
export type updateInvoiceResponseError = (updateInvoiceResponse400 | updateInvoiceResponse401 | updateInvoiceResponse403 | updateInvoiceResponse404 | updateInvoiceResponse422 | updateInvoiceResponse500) & {
  headers: Headers;
};

export type updateInvoiceResponse = (updateInvoiceResponseSuccess | updateInvoiceResponseError)

export const getUpdateInvoiceUrl = (id: string,) => {


  

  return `/invoices/${id}`
}

export const updateInvoice = async (id: string,
    updateInvoice: UpdateInvoice, options?: RequestInit): Promise<updateInvoiceResponse> => {
  
  return customFetch<updateInvoiceResponse>(getUpdateInvoiceUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateInvoice,)
  }
);}
  

/**
 * Retrieve the version history for an invoice. Each version represents the document state before an update was applied.
 * @summary Get invoice version history
 */
export type getInvoiceVersionsResponse200 = {
  data: DocumentVersionList
  status: 200
}

export type getInvoiceVersionsResponse401 = {
  data: Error
  status: 401
}

export type getInvoiceVersionsResponse403 = {
  data: Error
  status: 403
}

export type getInvoiceVersionsResponse404 = {
  data: Error
  status: 404
}

export type getInvoiceVersionsResponse500 = {
  data: Error
  status: 500
}

export type getInvoiceVersionsResponseSuccess = (getInvoiceVersionsResponse200) & {
  headers: Headers;
};
export type getInvoiceVersionsResponseError = (getInvoiceVersionsResponse401 | getInvoiceVersionsResponse403 | getInvoiceVersionsResponse404 | getInvoiceVersionsResponse500) & {
  headers: Headers;
};

export type getInvoiceVersionsResponse = (getInvoiceVersionsResponseSuccess | getInvoiceVersionsResponseError)

export const getGetInvoiceVersionsUrl = (id: string,) => {


  

  return `/invoices/${id}/versions`
}

export const getInvoiceVersions = async (id: string, options?: RequestInit): Promise<getInvoiceVersionsResponse> => {
  
  return customFetch<getInvoiceVersionsResponse>(getGetInvoiceVersionsUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retrieve a specific version snapshot of an invoice.
 * @summary Get specific invoice version
 */
export type getInvoiceVersionResponse200 = {
  data: DocumentVersion
  status: 200
}

export type getInvoiceVersionResponse401 = {
  data: Error
  status: 401
}

export type getInvoiceVersionResponse403 = {
  data: Error
  status: 403
}

export type getInvoiceVersionResponse404 = {
  data: Error
  status: 404
}

export type getInvoiceVersionResponse500 = {
  data: Error
  status: 500
}

export type getInvoiceVersionResponseSuccess = (getInvoiceVersionResponse200) & {
  headers: Headers;
};
export type getInvoiceVersionResponseError = (getInvoiceVersionResponse401 | getInvoiceVersionResponse403 | getInvoiceVersionResponse404 | getInvoiceVersionResponse500) & {
  headers: Headers;
};

export type getInvoiceVersionResponse = (getInvoiceVersionResponseSuccess | getInvoiceVersionResponseError)

export const getGetInvoiceVersionUrl = (id: string,
    version: number,) => {


  

  return `/invoices/${id}/versions/${version}`
}

export const getInvoiceVersion = async (id: string,
    version: number, options?: RequestInit): Promise<getInvoiceVersionResponse> => {
  
  return customFetch<getInvoiceVersionResponse>(getGetInvoiceVersionUrl(id,version),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Render an HTML preview of an invoice without saving to the database. Perfect for displaying live previews in invoice creation/edit forms. Supports both partial mode (allows incomplete data for drafts) and complete mode (validates all required fields).
 * @summary Render invoice preview
 */
export type renderInvoicePreviewResponse200 = {
  data: string
  status: 200
}

export type renderInvoicePreviewResponse400 = {
  data: Error
  status: 400
}

export type renderInvoicePreviewResponse401 = {
  data: Error
  status: 401
}

export type renderInvoicePreviewResponse403 = {
  data: Error
  status: 403
}

export type renderInvoicePreviewResponse404 = {
  data: Error
  status: 404
}

export type renderInvoicePreviewResponse422 = {
  data: ValidationError
  status: 422
}

export type renderInvoicePreviewResponse500 = {
  data: Error
  status: 500
}

export type renderInvoicePreviewResponseSuccess = (renderInvoicePreviewResponse200) & {
  headers: Headers;
};
export type renderInvoicePreviewResponseError = (renderInvoicePreviewResponse400 | renderInvoicePreviewResponse401 | renderInvoicePreviewResponse403 | renderInvoicePreviewResponse404 | renderInvoicePreviewResponse422 | renderInvoicePreviewResponse500) & {
  headers: Headers;
};

export type renderInvoicePreviewResponse = (renderInvoicePreviewResponseSuccess | renderInvoicePreviewResponseError)

export const getRenderInvoicePreviewUrl = (params?: RenderInvoicePreviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/invoices/render?${stringifiedParams}` : `/invoices/render`
}

export const renderInvoicePreview = async (partialInvoicePreviewCompleteInvoicePreview: PartialInvoicePreview | CompleteInvoicePreview,
    params?: RenderInvoicePreviewParams, options?: RequestInit): Promise<renderInvoicePreviewResponse> => {
  
  return customFetch<renderInvoicePreviewResponse>(getRenderInvoicePreviewUrl(params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      partialInvoicePreviewCompleteInvoicePreview,)
  }
);}
  

/**
 * Void an invoice for technical reasons (duplicate, error, etc.). For FURS-fiscalized invoices, automatically submits technical cancellation to FURS and creates a credit note. For business corrections, create a credit note instead.
 * @summary Void an invoice
 */
export type voidInvoiceResponse200 = {
  data: Invoice
  status: 200
}

export type voidInvoiceResponse400 = {
  data: Error
  status: 400
}

export type voidInvoiceResponse401 = {
  data: Error
  status: 401
}

export type voidInvoiceResponse403 = {
  data: Error
  status: 403
}

export type voidInvoiceResponse404 = {
  data: Error
  status: 404
}

export type voidInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type voidInvoiceResponse500 = {
  data: Error
  status: 500
}

export type voidInvoiceResponseSuccess = (voidInvoiceResponse200) & {
  headers: Headers;
};
export type voidInvoiceResponseError = (voidInvoiceResponse400 | voidInvoiceResponse401 | voidInvoiceResponse403 | voidInvoiceResponse404 | voidInvoiceResponse422 | voidInvoiceResponse500) & {
  headers: Headers;
};

export type voidInvoiceResponse = (voidInvoiceResponseSuccess | voidInvoiceResponseError)

export const getVoidInvoiceUrl = (id: string,) => {


  

  return `/invoices/${id}/void`
}

export const voidInvoice = async (id: string,
    voidInvoiceBody: VoidInvoiceBody, options?: RequestInit): Promise<voidInvoiceResponse> => {
  
  return customFetch<voidInvoiceResponse>(getVoidInvoiceUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      voidInvoiceBody,)
  }
);}
  

/**
 * Manually fiscalize an invoice that was created before FURS was enabled. Auto-creates a dedicated "OLD" premise and device for FURS submission, assigns a new sequential FURS number (OLD-OLD-N), and submits to FURS with SubsequentSubmit=true and SpecialNotes=#OLDINV;. The original invoice number remains unchanged.
 * @summary Fiscalize an old invoice
 */
export type fiscalizeInvoiceResponse200 = {
  data: Invoice
  status: 200
}

export type fiscalizeInvoiceResponse400 = {
  data: Error
  status: 400
}

export type fiscalizeInvoiceResponse401 = {
  data: Error
  status: 401
}

export type fiscalizeInvoiceResponse403 = {
  data: Error
  status: 403
}

export type fiscalizeInvoiceResponse404 = {
  data: Error
  status: 404
}

export type fiscalizeInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type fiscalizeInvoiceResponse500 = {
  data: Error
  status: 500
}

export type fiscalizeInvoiceResponseSuccess = (fiscalizeInvoiceResponse200) & {
  headers: Headers;
};
export type fiscalizeInvoiceResponseError = (fiscalizeInvoiceResponse400 | fiscalizeInvoiceResponse401 | fiscalizeInvoiceResponse403 | fiscalizeInvoiceResponse404 | fiscalizeInvoiceResponse422 | fiscalizeInvoiceResponse500) & {
  headers: Headers;
};

export type fiscalizeInvoiceResponse = (fiscalizeInvoiceResponseSuccess | fiscalizeInvoiceResponseError)

export const getFiscalizeInvoiceUrl = (id: string,) => {


  

  return `/invoices/${id}/fiscalize`
}

export const fiscalizeInvoice = async (id: string, options?: RequestInit): Promise<fiscalizeInvoiceResponse> => {
  
  return customFetch<fiscalizeInvoiceResponse>(getFiscalizeInvoiceUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Render a saved document by its ID as HTML. The document type is automatically detected from the ID prefix (inv_, est_, cre_, adv_). The output is styled for professional presentation and optimized for display in web applications.
 * @summary Render HTML
 */
export type renderDocumentHtmlResponse200 = {
  data: string
  status: 200
}

export type renderDocumentHtmlResponse401 = {
  data: Error
  status: 401
}

export type renderDocumentHtmlResponse403 = {
  data: Error
  status: 403
}

export type renderDocumentHtmlResponse404 = {
  data: Error
  status: 404
}

export type renderDocumentHtmlResponse500 = {
  data: Error
  status: 500
}

export type renderDocumentHtmlResponseSuccess = (renderDocumentHtmlResponse200) & {
  headers: Headers;
};
export type renderDocumentHtmlResponseError = (renderDocumentHtmlResponse401 | renderDocumentHtmlResponse403 | renderDocumentHtmlResponse404 | renderDocumentHtmlResponse500) & {
  headers: Headers;
};

export type renderDocumentHtmlResponse = (renderDocumentHtmlResponseSuccess | renderDocumentHtmlResponseError)

export const getRenderDocumentHtmlUrl = (id: string,
    params?: RenderDocumentHtmlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/documents/${id}/html?${stringifiedParams}` : `/documents/${id}/html`
}

export const renderDocumentHtml = async (id: string,
    params?: RenderDocumentHtmlParams, options?: RequestInit): Promise<renderDocumentHtmlResponse> => {
  
  return customFetch<renderDocumentHtmlResponse>(getRenderDocumentHtmlUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Render a saved document by its ID as PDF. The document type is automatically detected from the ID prefix (inv_, est_, cre_, adv_). The output is styled for professional presentation and optimized for printing. Ideal for downloads and archival.
 * @summary Render PDF
 */
export type renderDocumentPdfResponse200 = {
  data: Blob
  status: 200
}

export type renderDocumentPdfResponse401 = {
  data: Error
  status: 401
}

export type renderDocumentPdfResponse403 = {
  data: Error
  status: 403
}

export type renderDocumentPdfResponse404 = {
  data: Error
  status: 404
}

export type renderDocumentPdfResponse500 = {
  data: Error
  status: 500
}

export type renderDocumentPdfResponseSuccess = (renderDocumentPdfResponse200) & {
  headers: Headers;
};
export type renderDocumentPdfResponseError = (renderDocumentPdfResponse401 | renderDocumentPdfResponse403 | renderDocumentPdfResponse404 | renderDocumentPdfResponse500) & {
  headers: Headers;
};

export type renderDocumentPdfResponse = (renderDocumentPdfResponseSuccess | renderDocumentPdfResponseError)

export const getRenderDocumentPdfUrl = (id: string,
    params?: RenderDocumentPdfParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/documents/${id}/pdf?${stringifiedParams}` : `/documents/${id}/pdf`
}

export const renderDocumentPdf = async (id: string,
    params?: RenderDocumentPdfParams, options?: RequestInit): Promise<renderDocumentPdfResponse> => {
  
  return customFetch<renderDocumentPdfResponse>(getRenderDocumentPdfUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

